<template>
<v-card flat>
  <v-card-title class='ml-3 overline' >
    Delivery status
  </v-card-title>
  <v-list class='mx-4' dense >
    <v-list-tile v-for='comm in communications' :key='comm.id' >
      <v-list-tile-avatar >
        <v-icon v-if='!isFailure(comm)' >check</v-icon>
        <v-icon v-else >close</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content v-if='comm' >
        <v-list-tile-title v-if='comm.preferred_transport === "email"'>
          <span v-for='email in comm.recipient_emails' :key='email' >{{email}}</span>
        </v-list-tile-title>
        <v-list-tile-title v-if='comm.preferred_transport === "sms"'>
          <span >{{comm.recipient_phone_number}}</span>
        </v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action>
        {{ status(comm) }}
      </v-list-tile-action>
    </v-list-tile>
    <v-list-tile v-if='!communications || communications.length === 0' >
      <v-list-tile-avatar >
        <v-progress-circular indeterminate width=2 color='amber' >
        </v-progress-circular>
      </v-list-tile-avatar>
      <v-list-tile-content >
        <v-list-tile-title >
          waiting for status updates
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
  <v-card-text>
  <v-btn @click='get' :loading='request.loading' flat small >Fetch from server</v-btn>
  </v-card-text>
</v-card>
</template>
<script>

export default {
  name: 'MessageDeliveryStatus',
  props: {
    reqId: 'get-communication-request',
    batchId: { required: true }
  },
  computed: {
    communications () {
      return this.$store.getters.getCommsByBatchId(this.batchId)
    },
    request () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    requestStatus () {
      return this.request.status
    }
  },
  watch: {
    requestStatus () {
      if (this.requestStatus === 200) {
        let comms = this.geObjectPath(this.request, 'result.data.results', [])
        if (comms && comms.lenth > 0) {
          this.$store.commit('addManyCommunications', comms)
        }
      }
    }
  },
  methods: {
    isFailure (comm) {
      return (comm && comm.status.toLowerCase() === 'failed')
    },
    status (comm) {
      if (comm) {
        if (comm.communicationstatus && comm.communicationstatus.length > 0) {
          let stat = comm.communicationstatus[comm.communicationstatus.length - 1]
          if (stat) {
            return stat.status
          }
        }
        return 'sent'
      }
    },
    get () {
      let params = { batch_id: this.batchId }
      this.$communicationguru
        .resource('communication')
        .id(this.reqId)
        .list(params)
    }
  }
}
</script>



// WEBPACK FOOTER //
// MessageDeliveryStatus.vue?aba1adc2